// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"511":"8ac581db","673":"34a4f5e4","767":"f9498070"}[chunkId] + ".chunk.js";
};